import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import Reachout from "../../services/Reachout";

export const DeleteReachoutModal = ({
  isOpen,
  onClose,
  id,
  func,
}: //   price,
any) => {
  //   const token = localStorage.getItem("logged_in_user_token");
  const deleteReachout = async () => {
    try {
      const res = await Reachout.getDeleteCampaign(id);
      // console.log(res);
      func();
      onClose();
    } catch (error) {
      console.log(error);
      onClose();
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Reachout</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{`Are you sure you want to delete?`}</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deleteReachout}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
